import { render, staticRenderFns } from "./Nav1.vue?vue&type=template&id=80b0df0a&scoped=true&"
import script from "./Nav1.vue?vue&type=script&lang=js&"
export * from "./Nav1.vue?vue&type=script&lang=js&"
import style0 from "./Nav1.vue?vue&type=style&index=0&id=80b0df0a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b0df0a",
  null
  
)

export default component.exports